import {useMutation, type UseMutationOptions} from '@tanstack/react-query';
import {
	authenticate,
	type AuthenticateResult,
	type AuthenticateRequestOptions,
	type QueryError,
} from '../authenticate';
export * from '../authenticate';

export type UseReactQueryAuthenticateOptions = Omit<
	UseMutationOptions<
		AuthenticateResult,
		QueryError,
		AuthenticateRequestOptions,
		AuthenticateResult
	>,
	'mutationFn'
> & {
	mutationFn?: typeof authenticate;
};

export const useReactQueryAuthenticate = ({
	mutationFn = authenticate,
	...options
}: UseReactQueryAuthenticateOptions = {}) =>
	useMutation<
		AuthenticateResult,
		QueryError,
		AuthenticateRequestOptions,
		AuthenticateResult
	>({
		mutationFn,
		...options,
	});

export default useReactQueryAuthenticate;
